import React from 'react';

/**
 * Renderiza el bloque ActivityChart de SCAPP V2.
 *
 * @param {object} props
 * @param {object} props.v - Modelo de presentación y callbacks del panel.
 * @returns {React.ReactNode} Bloque visual sin estado local.
 */
export default function ActivityChart({
  v
}) {
  return React.createElement("div", {
    className: "scapp-detail-chart-row",
    style: {
      "display": v.showPrimary ? "grid" : "none",
      "gridTemplateColumns": "13.541667vw 2.291667vw minmax(0,1fr) 4.791667vw",
      "gap": "0",
      "alignItems": "center"
    }
  }, React.createElement("div", {
    style: {
      "display": "flex",
      "flexDirection": "column",
      "gap": "0.092593vh",
      "paddingRight": "0.208333vw"
    }
  }, React.createElement("button", {
    type: "button",
    "data-detail-legend": "activity",
    "aria-pressed": v.showActivitySeries,
    onClick: () => v.toggleDetailMetric("activity"),
    style: {
      "display": v.hasActivity ? "grid" : "none",
      "border": "0",
      "background": "transparent",
      "padding": "0",
      "width": "100%",
      "textAlign": "left",
      "cursor": "pointer",
      "opacity": v.showActivitySeries ? "1" : "0.38",
      "gridTemplateColumns": "0.625vw minmax(0,1fr) auto",
      "gap": "0.740741vh",
      "alignItems": "center",
      "fontSize": "1.203704vh",
      "lineHeight": "1.851852vh"
    }
  }, React.createElement("span", {
    style: {
      "width": "0.625vw",
      "height": "0.277778vh",
      "borderRadius": "0.185185vh",
      "background": "oklch(0.78 0.14 160)"
    }
  }, null), React.createElement("span", {
    style: {
      "color": "#b8c1ce",
      "whiteSpace": "nowrap",
      "overflow": "hidden",
      "textOverflow": "ellipsis"
    }
  }, React.createElement("span", {}, v.text("Actividad [%]"), (v.det.activities || []).length > 1 ? React.createElement("span", {
    title: (v.det.activities || []).map(activity => activity.name).join(" · "),
    style: {
      "display": "inline-flex",
      "gap": "0.277778vh",
      "marginLeft": "0.3125vw",
      "verticalAlign": "middle"
    }
  }, (v.det.activities || []).map((activity, activityIndex) => React.createElement("i", {
    key: activity.key || activityIndex,
    title: activity.name,
    style: {
      "display": "inline-block",
      "width": "0.364583vw",
      "height": "0.648148vh",
      "borderRadius": "50%",
      "background": activity.color
    }
  }, null))) : null)), React.createElement("span", {
    style: {
      "font": "600 1.296296vh 'IBM Plex Mono',monospace",
      "color": "oklch(0.78 0.14 160)",
      "opacity": v.vOp,
      "whiteSpace": "nowrap"
    }
  }, v.text(v.vA))), React.createElement("button", {
    type: "button",
    "data-detail-legend": "rate",
    "aria-pressed": v.showRateSeries,
    onClick: () => v.toggleDetailMetric("rate"),
    style: {
      "display": v.hasRate ? "grid" : "none",
      "border": "0",
      "background": "transparent",
      "padding": "0",
      "width": "100%",
      "textAlign": "left",
      "cursor": "pointer",
      "opacity": v.showRateSeries ? "1" : "0.38",
      "gridTemplateColumns": "0.625vw minmax(0,1fr) auto",
      "gap": "0.740741vh",
      "alignItems": "center",
      "fontSize": "1.203704vh",
      "lineHeight": "1.851852vh"
    }
  }, React.createElement("span", {
    style: {
      "width": "0.625vw",
      "height": "0.277778vh",
      "borderRadius": "0.185185vh",
      "background": "oklch(0.72 0.14 55)"
    }
  }, null), React.createElement("span", {
    style: {
      "color": "#b8c1ce",
      "whiteSpace": "nowrap",
      "overflow": "hidden",
      "textOverflow": "ellipsis"
    }
  }, v.text("Tasa [kg/min]")), React.createElement("span", {
    style: {
      "font": "600 1.296296vh 'IBM Plex Mono',monospace",
      "color": "oklch(0.72 0.14 55)",
      "opacity": v.vOp,
      "whiteSpace": "nowrap"
    }
  }, v.text(v.vT))), React.createElement("button", {
    type: "button",
    "data-detail-legend": "ppa",
    "aria-pressed": v.showPpaSeries,
    onClick: () => v.toggleDetailMetric("ppa"),
    style: {
      "display": v.hasPpa ? "grid" : "none",
      "border": "0",
      "background": "transparent",
      "padding": "0",
      "width": "100%",
      "textAlign": "left",
      "cursor": "pointer",
      "opacity": v.showPpaSeries ? "1" : "0.38",
      "gridTemplateColumns": "0.625vw minmax(0,1fr) auto",
      "gap": "0.740741vh",
      "alignItems": "center",
      "fontSize": "1.203704vh",
      "lineHeight": "1.851852vh"
    }
  }, React.createElement("span", {
    style: {
      "width": "0.625vw",
      "height": "0.277778vh",
      "borderRadius": "0.185185vh",
      "background": "oklch(0.68 0.2 25)"
    }
  }, null), React.createElement("span", {
    style: {
      "color": "#b8c1ce",
      "whiteSpace": "nowrap",
      "overflow": "hidden",
      "textOverflow": "ellipsis"
    }
  }, v.text("PPA acum. [pellets]")), React.createElement("span", {
    style: {
      "font": "600 1.296296vh 'IBM Plex Mono',monospace",
      "color": "oklch(0.68 0.2 25)",
      "opacity": v.vOp,
      "whiteSpace": "nowrap"
    }
  }, v.text(v.vP)))), React.createElement("div", {
    "onMouseMove": v.hMove,
    "onMouseLeave": v.hLeave,
    "onMouseDown": v.hDown,
    "onMouseUp": v.hUp,
    "onWheel": v.hWheel,
    "data-wheel-zoom": "1",
    style: {
      "gridColumn": "3",
      "position": "relative",
      "display": "flex",
      "flexDirection": "column",
      "cursor": v.hCursor,
      "userSelect": "none"
    }
  }, React.createElement("div", {
    style: {
      "position": "absolute",
      "left": "0",
      "right": "0",
      "top": "0",
      "bottom": "0",
      "pointerEvents": "none"
    }
  }, (v.det.axPrimary || []).map((t, index19) => React.createElement(React.Fragment, {
    key: index19
  }, React.createElement("div", {
    style: {
      "position": "absolute",
      "left": "0",
      "right": "0",
      "top": t.top,
      "borderTop": "0.092593vh solid rgba(135,147,166,0.13)"
    }
  }, null)))), React.createElement("div", {
    style: {
      "position": "absolute",
      "left": "-2.291667vw",
      "width": "2.291667vw",
      "top": "0",
      "bottom": "0",
      "pointerEvents": "none",
      "display": v.showActivitySeries ? "block" : "none",
      "borderRight": "0.052083vw solid oklch(0.78 0.14 160 / 0.55)"
    }
  }, (v.det.axA || []).map((t, index20) => React.createElement(React.Fragment, {
    key: index20
  }, React.createElement("span", {
    style: {
      "position": "absolute",
      "right": "0",
      "top": t.top,
      "width": "0.208333vw",
      "borderTop": "0.092593vh solid oklch(0.78 0.14 160)"
    }
  }, null), React.createElement("span", {
    style: {
      "position": "absolute",
      "right": "0.364583vw",
      "top": t.lt,
      "transform": "translateY(-50%)",
      "font": "0.925926vh 'IBM Plex Mono',monospace",
      "whiteSpace": "nowrap",
      "color": "oklch(0.78 0.14 160)"
    }
  }, v.text(t.lab))))), React.createElement("div", {
    style: {
      "position": "absolute",
      "left": "calc(100% + 0vw)",
      "width": "2.395833vw",
      "top": "0",
      "bottom": "0",
      "pointerEvents": "none",
      "display": v.showRateSeries ? "block" : "none",
      "borderLeft": "0.052083vw solid oklch(0.72 0.14 55 / 0.55)"
    }
  }, (v.det.axT || []).map((t, index21) => React.createElement(React.Fragment, {
    key: index21
  }, React.createElement("span", {
    style: {
      "position": "absolute",
      "left": "0",
      "top": t.top,
      "width": "0.208333vw",
      "borderTop": "0.092593vh solid oklch(0.72 0.14 55)"
    }
  }, null), React.createElement("span", {
    style: {
      "position": "absolute",
      "left": "0.364583vw",
      "top": t.lt,
      "transform": "translateY(-50%)",
      "font": "0.925926vh 'IBM Plex Mono',monospace",
      "whiteSpace": "nowrap",
      "color": "oklch(0.72 0.14 55)"
    }
  }, v.text(t.lab))))), React.createElement("div", {
    style: {
      "position": "absolute",
      "left": "calc(100% + 2.395833vw)",
      "width": "2.395833vw",
      "top": "0",
      "bottom": "0",
      "pointerEvents": "none",
      "display": v.showPpaSeries ? "block" : "none",
      "borderLeft": "0.052083vw solid oklch(0.68 0.2 25 / 0.55)"
    }
  }, (v.det.axP || []).map((t, index22) => React.createElement(React.Fragment, {
    key: index22
  }, React.createElement("span", {
    style: {
      "position": "absolute",
      "left": "0",
      "top": t.top,
      "width": "0.208333vw",
      "borderTop": "0.092593vh solid oklch(0.68 0.2 25)"
    }
  }, null), React.createElement("span", {
    style: {
      "position": "absolute",
      "left": "0.364583vw",
      "top": t.lt,
      "transform": "translateY(-50%)",
      "font": "0.925926vh 'IBM Plex Mono',monospace",
      "whiteSpace": "nowrap",
      "color": "oklch(0.68 0.2 25)"
    }
  }, v.text(t.lab))))), React.createElement("svg", {
    "viewBox": v.zVB,
    "preserveAspectRatio": "none",
    style: {
      "width": "100%",
      "height": v.dH.a / 10.8 + "vh",
      "display": "block",
      "background": "rgba(4,12,24,0.55)",
      "borderRadius": "0.37037vh"
    }
  }, React.createElement("path", {
    "d": v.czSpan,
    "fill": "oklch(0.66 0.19 42 / 0.16)",
    "stroke": "none"
  }, null), React.createElement("path", {
    "d": v.det.tasa,
    "display": v.showRateSeries ? "inline" : "none",
    "fill": "oklch(0.72 0.14 55 / 0.14)",
    "stroke": "oklch(0.72 0.14 55)",
    "strokeWidth": "1.8",
    "vectorEffect": "non-scaling-stroke"
  }, null), React.createElement("path", {
    "d": v.det.ppaCum,
    "display": v.showPpaSeries ? "inline" : "none",
    "fill": "none",
    "stroke": "oklch(0.68 0.2 25)",
    "strokeWidth": "2",
    "vectorEffect": "non-scaling-stroke",
    "strokeLinejoin": "round"
  }, null), (v.det.activities || [{
    path: v.det.act,
    color: "oklch(0.78 0.14 160)"
  }]).map((activity, activityIndex) => React.createElement("path", {
    key: activity.key || activityIndex,
    "d": activity.path,
    "display": v.showActivitySeries ? "inline" : "none",
    "stroke": activity.color,
    "strokeWidth": "2",
    "fill": "none",
    "vectorEffect": "non-scaling-stroke"
  }, null))), React.createElement("div", {
    style: {
      "position": "absolute",
      "inset": "0",
      "pointerEvents": "none",
      "overflow": "hidden"
    }
  }, (v.alarmPins || []).map((alarm, alarmIndex) => React.createElement(React.Fragment, {
    key: "alarm-" + (alarm.k ?? alarmIndex)
  }, alarm.reactionOn ? React.createElement("div", {
    "data-alarm-reaction": "1",
    style: {
      "position": "absolute",
      "left": alarm.left,
      "top": "50%",
      "width": alarm.reactionW,
      "height": "0.185185vh",
      "transform": "translateY(-50%)",
      "background": alarm.c,
      "opacity": "0.78",
      "pointerEvents": "none"
    }
  }, React.createElement("span", {
    style: {
      "position": "absolute",
      "right": "0",
      "top": "-0.462963vh",
      "width": "0.092593vh",
      "height": "1.111111vh",
      "background": alarm.c
    }
  }, null)) : null, React.createElement("button", {
    type: "button",
    "aria-label": "Alarma en el detalle diario",
    "data-detail-alarm": "1",
    title: "Alarma",
    onMouseEnter: alarm.enter,
    onMouseLeave: alarm.leave,
    onClick: alarm.onClick,
    style: {
      "position": "absolute",
      "left": alarm.left,
      "top": "50%",
      "width": "1.666667vh",
      "height": "1.666667vh",
      "padding": "0",
      "transform": "translate(-50%,-50%)",
      "border": "0",
      "background": "transparent",
      "filter": alarm.ring === "none" ? "drop-shadow(0 0 0.185185vh rgba(0,0,0,0.75))" : "drop-shadow(0 0 0.277778vh rgba(228,233,240,0.8))",
      "cursor": "pointer",
      "pointerEvents": "auto"
    }
  }, React.createElement("svg", {
    viewBox: "0 0 24 24",
    width: "100%",
    height: "100%",
    fill: alarm.c,
    "aria-hidden": "true"
  }, React.createElement("path", {
    d: alarm.important ? "M12 23c1.1 0 2-.9 2-2h-4c0 1.1.9 2 2 2zm9-4v-1l-2-2v-5c0-3.08-1.64-5.64-4.5-6.32V4c0-.83-.67-1.5-1.5-1.5S11.5 3.17 11.5 4v.68C8.63 5.36 7 7.92 7 11v5l-2 2v1h16zm-8-3h-2v-2h2v2zm0-4h-2V8h2v4z" : "M12 22c1.1 0 1.99-.9 1.99-2h-4c0 1.1.9 2 2.01 2zM18 16v-5c0-3.07-1.63-5.64-4.5-6.32V4c0-.83-.67-1.5-1.5-1.5S10.5 3.17 10.5 4v.68C7.64 5.36 6 7.92 6 11v5l-2 2v1h16v-1z"
  }, null))))), (v.notePins || []).map((note, noteIndex) => React.createElement("button", {
    key: "note-" + noteIndex,
    type: "button",
    "aria-label": note.label,
    "data-detail-note": "1",
    title: note.label,
    onMouseEnter: note.enter,
    onMouseLeave: note.leave,
    style: {
      "position": "absolute",
      "left": note.left,
      "top": "25%",
      "width": "1.666667vh",
      "height": "1.666667vh",
      "padding": "0",
      "transform": "translate(-50%,-50%)",
      "border": "0",
      "background": "transparent",
      "filter": note.active ? "drop-shadow(0 0 0.277778vh rgba(216,205,248,0.9))" : "drop-shadow(0 0 0.185185vh rgba(0,0,0,0.75))",
      "cursor": "help",
      "pointerEvents": "auto"
    }
  }, React.createElement("svg", {
    viewBox: "0 0 24 24",
    width: "100%",
    height: "100%",
    fill: "#8e6de8",
    "aria-hidden": "true"
  }, React.createElement("path", {
    d: "M21.99 4c0-1.1-.89-2-1.99-2H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h14l4 4-.01-18zM18 14H6v-2h12v2zm0-3H6V9h12v2zm0-3H6V6h12v2z"
  }, null))))), React.createElement("div", {
    style: {
      "position": "absolute",
      "top": "0",
      "bottom": "0",
      "left": v.hx,
      "width": "0.052083vw",
      "background": "#e4e9f0",
      "opacity": "0.55",
      "pointerEvents": "none",
      "display": v.hDisp
    }
  }, null), React.createElement("div", {
    style: {
      "position": "absolute",
      "top": "0",
      "bottom": "0",
      "left": v.selL,
      "width": v.selW,
      "background": "rgba(228,233,240,0.12)",
      "borderLeft": "0.052083vw solid #8793a6",
      "borderRight": "0.052083vw solid #8793a6",
      "pointerEvents": "none",
      "display": v.selD
    }
  }, null)));
}
